module.exports = __webpack_public_path__ + "media/goforajourney/img/mexico-city-card-29c3548967329badf17edcaade8833e3.webp";